<template>
  <div class="pageWrap">
      <div class="right">
        <div class="searchContent">
          <el-button icon="el-icon-plus" type="danger" @click="openAddBox">新增记录</el-button>
          <el-button type="warning" @click="openPutBox" plain>修改</el-button>
          <el-button type="info" plain @click="openDelBox">删除</el-button>
          <span class="searchInputText">类型</span>
          <el-select v-model="careType" placeholder="请选择类型">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <span class="searchInputText">维保内容</span>
          <el-input placeholder="请输入保养内容" v-model="maintaiSearch"></el-input>
          <el-button  type="danger" @click="doSearch">查找</el-button>
          <el-button type="info" plain @click="reset">重置</el-button>
        </div>
        <div class="listContain4">
          <div class="tablelistBody">
            <el-table
              :data="dataList"
              style="width: 100%"
              size="medium"
              height= '575px'
              v-loading="listLoading"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" min-width="5.476451%"></el-table-column>
              <el-table-column prop="order" label="序号" min-width="6.571741%"></el-table-column>
              <el-table-column prop="maintenanceContent" label="维保内容" min-width="20.429353%"></el-table-column>
              <el-table-column prop="type" label="类型" min-width="8.429353%">
                <template slot-scope="scope">
                  <span class="" v-if="scope.row.type == 0">保养</span>
                  <span class="" v-if="scope.row.type == 1">维修</span>
                </template>
              </el-table-column>
              <el-table-column prop="maintenanceTime" label="维保时间" min-width="16.429353%"></el-table-column>
              <el-table-column prop="time" label="本次保养小时" min-width="16.429353%">
                <template slot-scope="scope">
                  <span class="" v-if="scope.row.type == 0">{{scope.row.time}}</span>
                  <span class="" v-if="scope.row.type == 1">-</span>
                </template>
              </el-table-column>
              <el-table-column prop="planTime" label="计划下次保养小时" min-width="16.429353%">
                <template slot-scope="scope">
                  <span class="" v-if="scope.row.type == 0">{{scope.row.planTime}}</span>
                  <span class="" v-if="scope.row.type == 1">-</span>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="维保金额(元)" min-width="16.429353%"></el-table-column>
              <el-table-column prop="operator" label="维保负责人" min-width="16.429353%"></el-table-column>
              <el-table-column prop="contact" label="维保联系电话" min-width="16.429353%"></el-table-column>
              <el-table-column prop="remark" label="备注" min-width="21.905805%"></el-table-column>
            </el-table>
          </div>
           <div class="pageblock">
            <el-pageCover
              class="pageBlock"
              :pageMsg="pageMsg"
              :page-sizes="[5, 10]"
              :layout="layout"
              @sizeChange="pageSizeChange"
              @currentChange="currentPageChange"
            ></el-pageCover>
          </div>
        </div>
      </div>
      <el-dialog
        :title="actionName"
        :visible.sync="addModBoxVisible"
        :close-on-click-modal="false"
        width="400px"
        top="30vh"
      >
        <div class="borderBlock borderPadding addAndEdit takecare">
          <el-form
            :rules="rules"
            :model="modelObj"
            ref="addModForm"
            label-width="100px"
            @submit.native.prevent
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="类型" label-width="100px" required prop="type">
                  <el-select v-model="modelObj.type" placeholder="请选择类型">
                    <el-option
                      v-for="item in selectTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="modelObj.type==0?'保养内容':'维修内容'" label-width="100px" required prop="maintenanceContent">
                  <el-input  :validate-event="false" v-model="modelObj.maintenanceContent" maxlength="30" :placeholder="modelObj.type==0?'请输入保养内容':'请输入维修内容'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="modelObj.type==0?'保养时间':'维修时间'" label-width="100px" required prop="maintenanceTime">
                  <el-date-picker
                    :validate-event="false" 
                    v-model="modelObj.maintenanceTime"
                    type="datetime"
                    placeholder="请输入保养时间"
                    align="right"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    default-time="12:00:00"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="modelObj.type==0?'保养金额(元)':'维修金额(元)'" label-width="100px" required prop="money">
                  <el-input  :validate-event="false" v-model="modelObj.money" maxlength="30" :placeholder="modelObj.type==0?'请输入保养金额':'请输入维修金额'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="modelObj.type==0">
              <el-col :span="12">
                <el-form-item label="本次保养小时" label-width="100px" required prop="time">
                  <el-input type="number" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" :validate-event="false" v-model="modelObj.time" maxlength="30" placeholder="请输入本次保养小时"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="计划下次保养小时" label-width="100px" required prop="planTime">
                  <el-input type="number" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" :validate-event="false" v-model="modelObj.planTime" maxlength="30" placeholder="请输入计划下次保养小时"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="modelObj.type==0?'保养负责人':'维修负责人'" label-width="100px" prop="operator">
                  <el-input  :validate-event="false"  v-model="modelObj.operator" maxlength="10" :placeholder="modelObj.type==0?'请输入保养负责人':'请输入维修负责人'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="modelObj.type==0?'保养联系电话':'维修联系电话'" label-width="100px" prop="contact">
                  <el-input :validate-event="false"  v-model="modelObj.contact" maxlength="11" :placeholder="modelObj.type==0?'请输入保养联系电话':'请输入维修联系电话'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="备注" label-width="100px" prop="remark">
                  <el-input v-model="modelObj.remark" type="textarea" autosize></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="clear:both"></div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addModBoxVisible = false">取消</el-button>
          <el-button type="primary" @click="addModSubmit">{{actionName}}</el-button>
        </span>
      </el-dialog>
      <div class="deletedialog">
        <el-dialog :title="actionName" :visible.sync="delModBoxVisible" width="25%" top="40vh">
          <span class="el-icon-warning" style="color: #E96B5A;"></span>
          <span style="fontSize:16px">确认对所选记录进行删除吗?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="delModBoxVisible = false;modelObj={}">取 消</el-button>
            <el-button type="primary" @click="delModSubmit">{{actionName}}</el-button>
          </span>
        </el-dialog>
      </div> 
    </div>
</template>
<script>
import { Message } from "element-ui";
import ElPageCover from "../../../components/overall/ElPageCover";
import { toChineseDate } from "../../../utils/commons";
import { getEquipCareResume, addEquipMaintain,equipUpdateMaintain,equipDeleteMaintain,getEquipCareResumeFont} from "../../../utils/api";
export default {
  data() {
    return {
      multipleSelection: [],
      actionName: "",
      modelObj: {},
      maintaiSearch:'',
      addModBoxVisible: false,
      delModBoxVisible: false,
      period: "0",
      chartOption: {},
      listLoading:false,
      layout: " prev, pager, next, sizes, jumper , total",
      pageMsg: {
        pageSize: 5,
        pageNo: 1,
        totalRecords: 0,
      },
      dataList: [
      ],
      typeList:[
        {
          label:'全部',
          value:''
        },
        {
          label:'保养',
          value:0
        },
        {
          label:'维修',
          value:1
        }
      ],
      selectTypeList:[
        {
          label:'保养',
          value:0
        },
        {
          label:'维修',
          value:1
        }
      ],
      careType:'',
    };
  },
  props: ["code","workIndex"],
  watch:{
      workIndex(val){
          if(val==4){
              this.getEquipCare();
          }
      },
      code(){
        this.reset();
      }
  },
  computed: {
    rules: function () {
      return {
        maintenanceContent: [{ required: true, message: "必填" }],
        maintenanceTime: [{ required: true, message: "必填" }],
        money: [{ required: true, message: "必填" }],
        type: [{ required: true, message: "必填" }],
        time: [{ required: true, message: "必填" }],
        planTime: [{ required: true, message: "必填" }],
      };
    },
  },
  created() {},
  mounted() {
    this.getEquipCare();
  },
  components: { ElPageCover },
  methods: {
    
    //分页
    pageSizeChange(size){
      this.pageMsg.pageSize=size;
      if(this.maintaiSearch.trim()!=""){
        this.doSearch();//判断是否是搜索
      }else{
        this.getEquipCare();
      }
    },
    currentPageChange(index){
      this.pageMsg.pageNo=index;
       if(this.maintaiSearch.trim()!=""){
        this.doSearch();//判断是否是搜索
      }else{
        this.getEquipCare();
      }
    },
    getEquipCare(){
      this.listLoading=true;
      getEquipCareResume({code:this.code,type:this.careType,pageNo:this.pageMsg.pageNo,pageSize:this.pageMsg.pageSize}).then(res=>{
              const info=res.data.content.info;
              if(!info.pageSize){
                this.dataList=[];
                this.listLoading=false;
                this.pageMsg={
                pageNo:1,
                pageSize: 5,
                totalRecords: 0,
                };
                return 
              }
              this.pageMsg={
                pageNo:info.pageNo,
                pageSize: info.pageSize,
                totalRecords: info.totalRecords,
              };
              this.listLoading=false;
              this.dataList=info.list.map((item,index)=>{
                return {
                  order:(info.pageNo-1)*info.pageSize+index+1,
                  maintenanceContent: item.maintenanceContent,
                  maintenanceTime: item.maintenanceTime==null?'':toChineseDate(item.maintenanceTime+""),
                  operator: item.operator,
                  contact: item.contact,
                  remark: item.remark,
                  id:item.id,
                  time:item.time,
                  planTime:item.planTime,
                  money:item.money,
                  type:item.type*1
                  }
              });
            }) 
    },
    reset(){
      this.pageMsg.pageSize=5;
      this.pageMsg.pageNo=1;
      this.maintaiSearch='';
      this.careType='';
      this.getEquipCare();
    },
    getEquipCareResumeFontFun(){
      this.listLoading=true;
      getEquipCareResumeFont({
        code:this.code,
        pageSize:this.pageMsg.pageSize,
        pageNo:this.pageMsg.pageNo,
        content:this.maintaiSearch,
        type:this.careType
        }).then(res=>{
        const info=res.data.content.info;
          if(!info.pageSize){
            this.dataList=[];
            this.listLoading=false;
            this.pageMsg={
            pageNo:1,
            pageSize: 5,
            totalRecords: 0,
            };
            return 
          }
          this.pageMsg={
            pageNo:info.pageNo,
            pageSize: info.pageSize,
            totalRecords: info.totalRecords,
          };
          this.listLoading=false;
          this.dataList=info.list.map((item,index)=>{
            return {
              order:(info.pageNo-1)*info.pageSize+index+1,
              maintenanceContent: item.maintenanceContent,
              maintenanceTime: item.maintenanceTime==null?'':toChineseDate(item.maintenanceTime+""),
              operator: item.operator,
              contact: item.contact,
              remark: item.remark,
              id:item.id,
              time:item.time,
              planTime:item.planTime,
              money:item.money,
              type:item.type*1
            }
          });
      });
    },
    doSearch(){
      this.pageMsg.pageNo=1
      this.getEquipCareResumeFontFun()
    },
    openAddBox() {
      this.addModBoxVisible = true;
      this.actionName = "新增记录";
      this.$refs["addModForm"].clearValidate();
    },
    addModSubmit(){
      this.$refs['addModForm'].validate((valid)=>{
        if(valid){
          let params={};
          if(this.actionName=="新增记录"){
            this.addModBoxVisible = false;
            params={...this.modelObj,equipCode:this.code};
            addEquipMaintain(params).then(res=>{
            if(res.data.code==200){
              this.getEquipCare();
              this.modelObj={};
              this.maintaiSearch=""; 
              Message.success("添加成功");
            }
          }).catch(error=>{
              console.log(error);
              Message.error("添加失败");   
          })
          }else{
                this.addModBoxVisible = false;
                params={
                  id:this.modelObj.id,
                  maintenanceContent: this.modelObj.maintenanceContent,
                  maintenanceTime: this.modelObj.maintenanceTime,
                  time: this.modelObj.time,
                  planTime: this.modelObj.planTime,
                  operator: this.modelObj.operator,
                  contact: this.modelObj.contact,
                  remark: this.modelObj.remark,
                  money: this.modelObj.money
                };
                equipUpdateMaintain(params).then(res=>{
                if(res.data.code==200){
                  this.modelObj={}; 
                  Message.success("修改成功");
                  if(this.maintaiSearch.trim()!=""){
                    this.doSearch();//判断是否是搜索
                  }else{
                    this.getEquipCare();
                    }
                  }
                }
              ).catch(error=>{
                  console.log(error);
                  Message.error("修改失败");
              })
            }
        }else{
          return false
        }
      })
      
    },
    openPutBox() {
      this.actionName = "修改记录";
      if(this.multipleSelection.length==0){
          Message.warning("请选择修改项！")
          return;
        }else if(this.multipleSelection.length>1){
           Message.warning("仅支持单条记录修改！")
           return;
        }else{
          this.addModBoxVisible = true;
          this.modelObj = { ...this.multipleSelection[0] };
          this.modelObj.maintenanceTime=this.modelObj.maintenanceTime.replace("年","-").replace("月","-").replace("日","");
        }
        this.$refs["addModForm"].clearValidate();
    },
    openDelBox() {
      if(this.multipleSelection.length==0){
          Message.warning("请选择删除项！")
          return;
      }
      this.delModBoxVisible = true;
      this.actionName = "删除记录";
    },
    delModSubmit(){
      let str="";
      str=this.multipleSelection.map((item)=>{
        return item.id
      }).join(",");
      this.delModBoxVisible = false;
      equipDeleteMaintain({ids:str}).then(res=>{
        if(res.data.content.dataList.length==0){
          Message.error("删除失败");
        }
        let deleteList = str.split(",")
        if(deleteList.length == this.dataList.length){
          if(this.pageMsg.pageNo > 1){
            this.pageMsg.pageNo = this.pageMsg.pageNo -1
          }else{
            this.pageMsg.pageNo = 1
          }
        }
        if(this.maintaiSearch.trim()!=""){
           this.doSearch();//判断是否是搜索
          }else{
            this.getEquipCare();
          }
      }).catch(error=>{
        console.log(error);
        Message.error("删除失败");
      })
    },
    //表格勾选触发函数
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.modelObj = { ...this.multipleSelection[0] };
      this.modelObj.maintenanceTime=this.modelObj.maintenanceTime.replace("年","-").replace("月","-").replace("日","");
      
    },
  },
  
}
</script>
<style lang="scss">
  .deletedialog{
    .el-dialog {
    width: 400px !important;
    }
  }
  .takecare {
    .el-input {
      width: 220px !important;
    }
}
.listContain4 {
      .tablelistBody{
        .el-table{
          height: 575px !important;
          .el-table__body-wrapper{
            height: 531px !important;
          }
        }
        // overflow: auto;
      }
  }
</style>
<style lang="scss" scoped="">
.pageWrap {
  width: 100%;
  height: 658px;
    .right {
      width: 100%;
      height: 568px;
      padding-top: 20px;
      .searchContent {
        height: 65px;
        width: 80%;
        padding: 10.5px 17px;
      }
      .listContain4 {
        width: 98.5%;
        margin: 0 auto;
        position: relative;
        .tablelistBody {
          margin-left: 6px;
          height: 575px;
        }
        .pageblock {
          position: absolute;
          top: 560px;
          right: 20px;
        }
      }
    }
}
</style>